/* tslint:disable */
/* eslint-disable */
export enum PatchPrebidConflictType {
  UnexpectedState = 'unexpected_state',
  CreditLimitExceeded = 'credit_limit_exceeded'
}
